import { useState, useEffect } from 'react'
import { minBreakpoints } from '@/constants/breakpoints'

export function useMediaQuery(query: keyof typeof minBreakpoints | string): boolean {
  const [matches, setMatches] = useState(false)

  useEffect(() => {
    const mediaQuery = typeof minBreakpoints[query as keyof typeof minBreakpoints] === 'string'
      ? minBreakpoints[query as keyof typeof minBreakpoints]
      : query
    const media = window.matchMedia(mediaQuery)
    setMatches(media.matches)

    const listener = (e: MediaQueryListEvent) => setMatches(e.matches)
    media.addEventListener('change', listener)
    return () => media.removeEventListener('change', listener)
  }, [query])

  return matches
}
